export const calculateExpensesSums = (expenses, type) => {
  return expenses.reduce(
    (sums, expense) => {
      const ecrituresSum = expense.ecritures.reduce(
        (ecritureSums, ecriture) => ({
          montant: ecritureSums.montant + ecriture.montant,
          tva: ecritureSums.tva + ecriture.tva,
          recuperable: ecritureSums.recuperable + ecriture.recuperable,
          deductible: ecritureSums.deductible + ecriture.deductible,
        }),
        { montant: 0, tva: 0, recuperable: 0, deductible: 0 }
      )

      return {
        montant:
          sums.montant +
          (type === 'produit'
            ? -1 * ecrituresSum.montant
            : ecrituresSum.montant),
        tva: sums.tva + ecrituresSum.tva,
        recuperable: sums.recuperable + ecrituresSum.recuperable,
        deductible: sums.deductible + ecrituresSum.deductible,
      }
    },
    { montant: 0, tva: 0, recuperable: 0, deductible: 0 }
  )
}

export const calculateTypeSums = (groupedByKey, type) => {
  let result = { montant: 0, tva: 0, recuperable: 0, deductible: 0 }

  for (const key in groupedByKey) {
    const keyGroup = groupedByKey[key]
    const typeSums = calculateExpensesSums(keyGroup, type)
    result.montant += typeSums.montant
    result.tva += typeSums.tva
    result.recuperable += typeSums.recuperable
    result.deductible += typeSums.deductible
  }

  return result
}
